'use strict'

// An agent's display name in the active interface language — ONE helper for
// the whole workspace: the shared base owns it (shared/functions/
// agentDisplayName.js, workspace 0b1e3190e, where the chat's @-mention picker
// uses it too — shared cannot import canvas) and registers it from shared's
// functions index. Canvas reaches it through the bare shared-library import,
// the same deferred call wrapper components/PageSlot.js uses: a deep
// `@symbo-ls/workspace-shared/functions/…` re-export is stubbed by frank (the
// library is declared), so it published as "" and frank refused the canvas
// push. The local name is canvas-prefixed so it never collides with shared's
// own `agentDisplayName` in a catalog's single globalScope.
import _wsShared from '@symbo-ls/workspace-shared'
export const canvasAgentDisplayName = (...args) => _wsShared.functions.agentDisplayName(...args)
